import { render, staticRenderFns } from "./LmsPrivateMessages.vue?vue&type=template&id=6b1b2104"
import script from "./LmsPrivateMessages.vue?vue&type=script&lang=js"
export * from "./LmsPrivateMessages.vue?vue&type=script&lang=js"
import style0 from "./LmsPrivateMessages.vue?vue&type=style&index=0&id=6b1b2104&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports